<template>
  <div class="fair-survey-step fair-survey-step--welcome">
    <div class="fair-survey-step__head">
      <span class="fair-survey-step__eyebrow">Мои размеры</span>
      <h1 class="fair-survey-step__title fair-survey-step__title--hero">
        {{ step.title }}
      </h1>
      <p
        v-if="step.subtitle"
        class="fair-survey-step__subtitle"
      >
        {{ step.subtitle }}
      </p>
    </div>

    <ul class="fair-survey-step__facts">
      <li
        v-for="fact in FACTS"
        :key="fact"
        class="fair-survey-step__fact"
      >
        {{ fact }}
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
/**
 * Opening screen of the size survey.
 *
 * The redesign drops the AI avatar: the illustration carried no information
 * and pushed the copy off the first screen on short viewports. What the user
 * needs here is what the survey will ask and what it gives back.
 */
import type { SurveyStep } from '@/features/survey/types/survey-config'

defineProps<{ step: SurveyStep & { type: 'welcome' } }>()

const FACTS = [
  'Несколько мерок — рост, вес и обхваты',
  'Размеры для верха, низа, обуви и белья',
  'Можно прерваться — ответы сохранятся',
]
</script>

<style scoped>
.fair-survey-step--welcome {
  justify-content: center;
  gap: var(--fair-rd-space-40);
  padding-block: var(--space-32);
}

.fair-survey-step__title--hero {
  font-size: 44px;
  line-height: 1.05;
}

:global(.fair-survey-dialog--compact) .fair-survey-step__title--hero {
  font-size: 28px;
}

.fair-survey-step__facts {
  display: flex;
  flex-direction: column;
  gap: var(--space-12);
  margin: 0;
  padding: 0;
  list-style: none;
}

.fair-survey-step__fact {
  padding-block: var(--space-12);
  border-top: 1px solid var(--color-line-hairline);
  font-family: var(--fair-font-body, Inter, sans-serif);
  font-size: 15px;
  line-height: 1.3;
  color: var(--color-text-secondary);
}

.fair-survey-step__fact:last-child {
  border-bottom: 1px solid var(--color-line-hairline);
}
</style>
